//fake enum for body part IDs

import {BPID} from '../enums/BodyPartIdEnum.js';
export const BodyPartNames = {
    [BPID.HEAD]: "Hoofd",
    [BPID.EYES]: "Ogen",
    [BPID.EYEBROW]: "Wenkbrauwen",
    [BPID.EAR_LEFT]: "Oor",
    [BPID.EAR_RIGHT]: "Oor",
    [BPID.ANTENNA]: "Antenna",
    [BPID.WHISKERS]: "Snorharen",
    [BPID.SNOUT]: "Snuit",
    [BPID.NOSE]: "Neus",
    [BPID.MOUTH]: "Mond",
    [BPID.MIDDLE]: "Middel",
    [BPID.ARM_LEFT]: "Arm",
    [BPID.ARM_RIGHT]: "Arm",
    [BPID.LEG_LEFT]: "Been",
    [BPID.LEG_RIGHT]: "Been",
    'colors': "Kleuren",
}